import { inject, Injectable } from '@angular/core';
import { InsurancePlanDto, InsurancePlanPriceDto } from '../dto/insurance/insurance-plan.dto';
import { InsurancePlan, InsurancePlanPrice } from '../model/insurance/insurance-plan.model';
import { BaseMapper } from './base-mapper';

@Injectable({
    providedIn: 'root',
})
export class InsurancePlanMapper extends BaseMapper<InsurancePlan, InsurancePlanDto> {
    private readonly insurancePlanPriceMapper = inject(InsurancePlanPriceMapper);

    public mapDtoToModel(dto: InsurancePlanDto): InsurancePlan {
        return {
            id: dto.id,
            name: dto.name,
            description: dto.description,
            insurancePlanType: dto.insurancePlanType,
            type: dto.type,
            billingCycle: dto.billingCycle,
            commitmentPeriodMonths: dto.commitmentPeriodMonths,
            durationMonths: dto.durationMonths,
            autoRenewalDurationMonths: dto.autoRenewalDurationMonths,
            price: dto.price
                ? this.insurancePlanPriceMapper.mapDtoToModel(dto.price)
                : {
                      uuid: '',
                      price: 0,
                      currency: '',
                      priceType: '',
                      validFrom: '',
                      validUntil: '',
                  },
        };
    }
}

@Injectable({
    providedIn: 'root',
})
export class InsurancePlanPriceMapper extends BaseMapper<InsurancePlanPrice, InsurancePlanPriceDto> {
    public mapDtoToModel(dto: InsurancePlanPriceDto): InsurancePlanPrice {
        return {
            uuid: dto.uuid,
            price: dto.price,
            currency: dto.currency,
            priceType: dto.priceType,
            validFrom: dto.validFrom,
            validUntil: dto.validUntil,
        };
    }
}
